import {useMountedTruck} from "./mountedTruck.ts";
import {Tripleg, watchLastTriplegForTruckTqo} from "../rpc/webrpc-client.gen.ts";
import {InfallibleUseResult, transformUseResult} from "../util/hookutil.tsx";
import {useRefreshableInfallibleQuery} from "../util/tqrefresh.tsx";
import {useMothership} from "../tq/tqx.tsx";

export function useMyLastTripleg(): InfallibleUseResult<Tripleg | null> {
    const mama = useMothership();
    const mountedTruckTqrv = useMountedTruck();
    const mountedTruck = mountedTruckTqrv.data;
    return transformUseResult({
        from: useRefreshableInfallibleQuery(watchLastTriplegForTruckTqo(mama,
            mountedTruck ? {truckId: mountedTruck.id} : undefined)),
        via: (from) => from ?? null
    });
}


